/**
 * Журнал сетевых запросов (.har) записи бага: типы и разбор для просмотра
 * в карточке задачи (AttachmentHar).
 */

export interface HarPair {
  name: string;
  value: string;
}

export interface HarEntry {
  startedDateTime: string;
  time: number;
  _resourceType?: string;
  _error?: string;
  request: { method: string; url: string; headers: HarPair[]; postData?: { mimeType: string; text: string } };
  response: {
    status: number;
    statusText: string;
    headers: HarPair[];
    /** encoding "base64" — двоичное тело (картинка, шрифт); comment — почему тела нет. */
    content: { size: number; mimeType: string; text?: string; encoding?: string; comment?: string };
  };
}

export interface HarLog {
  log: { pages?: { startedDateTime: string }[]; entries: HarEntry[] };
}

export function isFailed(entry: HarEntry): boolean {
  return entry._error !== undefined || entry.response.status === 0 || entry.response.status >= 400;
}

/** Разбор файла; null — это не HAR. */
export function parseHar(text: string): HarLog | null {
  try {
    const value = JSON.parse(text) as HarLog;
    return Array.isArray(value.log.entries) && value.log.entries.every(validEntry) ? value : null;
  } catch {
    return null;
  }
}

function pairs(value: unknown): value is HarPair[] {
  return Array.isArray(value) && value.every((pair: HarPair | null) =>
    pair !== null && typeof pair.name === "string" && typeof pair.value === "string",
  );
}

function validEntry(entry: HarEntry): boolean {
  return entry !== null && typeof entry === "object"
    && typeof entry.startedDateTime === "string" && Number.isFinite(Date.parse(entry.startedDateTime))
    && typeof entry.time === "number" && Number.isFinite(entry.time)
    && typeof entry.request?.method === "string" && typeof entry.request.url === "string"
    && pairs(entry.request.headers)
    && (entry.request.postData === undefined || (typeof entry.request.postData?.text === "string" && typeof entry.request.postData.mimeType === "string"))
    && typeof entry.response?.status === "number" && typeof entry.response.statusText === "string"
    && pairs(entry.response.headers)
    && typeof entry.response.content?.mimeType === "string"
    && (entry.response.content.text === undefined || typeof entry.response.content.text === "string")
    && (entry.response.content.comment === undefined || typeof entry.response.content.comment === "string")
    && (entry.response.content.encoding === undefined || typeof entry.response.content.encoding === "string")
    && (entry._resourceType === undefined || typeof entry._resourceType === "string")
    && (entry._error === undefined || typeof entry._error === "string");
}
